import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-visibility-button',
  templateUrl: './toggle-visibility-button.component.html',
})
export class ToggleVisibilityButtonComponent {
  private _filterActive = true;

  @Input() label = '';

  @Input()
  set initialState(active: boolean) {
    this._filterActive = active;
  }

  @Output() toggleFilter = new EventEmitter();

  get filterButtonProps() {
    return this._filterActive
      ? {
          label: `Show ${this.label}`,
          icon: 'bi-eye',
        }
      : {
          label: `Hide ${this.label}`,
          icon: 'bi-eye-slash-fill',
        };
  }

  onToggle() {
    this._filterActive = !this._filterActive;
    this.toggleFilter.emit(this._filterActive);
  }
}
